import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import colors from "./colors";
import { ThemeProps } from "./themes";
import { Element } from "react-scroll";
import { Table } from "@mui/material";

type GlobalThemeProps = {
  theme: ThemeProps;
};

/*************** SELECT *****************/
export const StyledDropdownWrapper = styled.select`
    box-sizing: border-box;
    height: 54px;
    width: 294px;
    border: 2px solid #979797;
    border-radius: 3px;
    background-color: #ffffff;
    font-size: 1.1em;
    font-weight: 300;
    padding: 10px;
    margin: 5px 0px;
`;

/*************** HEADER *****************/

export const StyledHeaderWrapper = styled.header`
  white-space: pre-line;
  width: 80%;
  background-color: ${colors.bgSecondary};
  min-height: 200px;
  margin-top: 50px;
  float: right;

  h1 {
    font-weight: bold;
    font-size: 2.25em;
  }

  p {
    font-family: ${({ theme }: GlobalThemeProps) => theme.fontFamily2};
  }

  @media only screen and (max-width: 900px) {
    width: 100%;
  }
`;

export const StyledHeaderContent = styled.div`
  padding: 50px;
`;

/*************** SELECT *****************/

export const StyledSelectWrapper = styled.div`
  background-color: ${colors.selectedBg};
  border: 2px solid ${colors.selectedBorder};
  width: 100%;
  margin: 50px;

  @media only screen and (max-width: 700px) {
    alig-self: center;
    width: 95%;
    margin: 50px 0px;
  }
`;

export const StyledSelectContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;

  h2 {
    display: flex;
    gap: 15px;
    margin-bottom: 40px;
    margin-top: 0;
    font-weight: bold;
  }

  @media only screen and (max-width: 700px) {
    padding: 20px;
  }
`;

/*************** RADIOGROUP *****************/

export const StyledCircle = styled.span`
  flex: 0 0 26px;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  border: 1px solid #333333;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-right: 10px;
  left: 0;

  span {
    height: 22px;
    width: 22px;
  }
`;

export const StyledRadioLabel = styled.label`
  cursor: pointer;
  line-height: 1;
  width: 100%;
  padding-top: 17px;
  padding-bottom: 17px;
  display: flex;
  align-items: center;

  &:focus-visible {
    outline-color: ${({ theme }: GlobalThemeProps) => theme.background};
  }

  &:first-line {
    line-height: 2.5;
  }
`;

export const StyledRadioWrapper = styled.div`
  margin-bottom: 12px;
  width: 100%;
  position: relative;
  display: inline-flex;
  align-items: center;
  background-color: ${colors.bgSecondary};
`;

export const StyledRadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 50%;

  @media only screen and (max-width: 700px) {
    width: 100%;
  }
`;

export const StyledRadioButton = styled.input`
  display: none;

  &:checked + ${StyledRadioLabel} {
    background: ${({ theme }: GlobalThemeProps) => theme.background};
    color: white;
    font-weight: bold;

    &:after {
      @media only screen and (min-width: 700px) {
        content: "";
        position: absolute;
        left: 99.9%;
        top: 0;
        right: 0;
        width: 50%;
        height: 100%;
        max-width: 200px;

        clip-path: polygon(0% 0%, 0% 100%, 15% 50%);
        background: ${({ theme }: GlobalThemeProps) => theme.background};
      }
    }
  }

  &:checked + ${StyledRadioLabel} > ${StyledCircle} {
    border: 2px solid white;
  }

  &:checked + ${StyledRadioLabel} > ${StyledCircle} {
    span {
      border-radius: 50%;
      border: 2px solid ${({ theme }: GlobalThemeProps) => theme.background};
      background-color: white;
    }
  }
`;

/*************** COLOR-RADIOGROUP *****************/

export const StyledColorRadioSpan = styled.span`
  height: 86px;
  width: 86px;
  cursor: pointer;
  text-align: center;
  position: absolute;

  &:focus-visible {
    outline-color: ${({ theme }: GlobalThemeProps) => theme.background};
  }
`;

export const StyledColorRadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 150px;
`;

export const StyledColorRadioGroupWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 900px) {
    justify-content: center;
  }
`;

export const StyledColorCircle = styled.div`
  height: 86px;
  width: 86px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledColorRadioButton = styled.input`
  display: none;

  &:checked + ${StyledColorCircle} {
    color: white;
    font-weight: bold;

    &:after {
      content: "";
      height: 50px;
      width: 50px;
      border-radius: 50%;
      display: inline-block;
      background: ${({ theme }: GlobalThemeProps) => theme.background};
    }
  }

  &:checked + ${StyledColorCircle} + ${StyledColorRadioSpan} {
    font-weight: bold;
  }
`;

/*************** CARD *****************/

export const StyledCard = styled.div`
  background-color: ${colors.bgSecondary};
  margin-left: 40px;
  min-height: 550px;
  width: 50%;
  img {
    width: 100%;
  }

  @media only screen and (max-width: 700px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const StyledEmptyCard = styled.div`
  background-color: ${colors.bgSecondary};
  margin-left: 40px;
  width: 50%;
  min-height: 550px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  float: right;

  p {
    padding: 20px;
  }

  @media only screen and (max-width: 700px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const StyledCardTxtContent = styled.div`
  h3 {
    margin-top: 0px;
    font-size: 1.1em;
    font-weight: bold;
  }
  padding: 30px;
`;

/*************** BUTTON *****************/

export const StyledButton = styled.button`
  font-family: ${({ theme }: GlobalThemeProps) => theme.fontFamily2};
  color: ${colors.bgSecondary};
  font-weight: bold;
  padding: 17px 18px;
  background-color: ${({ theme }: GlobalThemeProps) => theme.background};
  align-self: baseline;
  font-size: 1.1em;
  border: none;
  cursor: pointer;
  margin-top: 30px;
  font-weight: bold;

  :disabled {
    cursor: not-allowed;
    background-color: ${colors.buttonDisabled};
    pointer-events: all !important;
  }
`;

export const StyledClearButton = styled(StyledButton)`
font-family: ${({ theme }: GlobalThemeProps) => theme.fontFamily2};
  color: ${({ theme }: GlobalThemeProps) => theme.background};
  font-size: 0.9em;
  background-color: ${colors.bgSecondary};
  padding: 15px 18px;
  border: 2px solid ${({ theme }: GlobalThemeProps) => theme.background};
  margin-right: 20px;
  }
`;

export const StyledLink = styled.a`
  color: ${colors.linkPrimary};
  background: none;
  border: none;
  font-size: 1.12em;
  font-weight: bold;
  text-decoration: underline;
  float: right;
  margin-top: 30px;
  cursor: pointer;

  @media only screen and (max-width: 1000px) {
    float: unset;
  }
`;
/*************** SIDEBAR *****************/

export const StyledSidebar = styled.div`
  width: 240px;
  float: left;
  position: fixed;

  a {
    &.Active {
      background-color: ${({ theme }: GlobalThemeProps) => theme.background};
      color: ${colors.bgSecondary};
    }
    align-items: baseline;
    padding: 20px 20px;
    text-decoration: none;
    font-size: 1.5em;
    color: ${colors.txtPrimary};
    display: flex;
    gap: 20px;
    background-color: ${colors.bgSecondary};
    margin-bottom: 8px;
    font-size: 1em;
    justify-content: space-between;

    &:focus {
      background-color: ${({ theme }: GlobalThemeProps) => theme.background};
      color: ${colors.bgSecondary};
      font-weight: bold;
    }
  }

  @media only screen and (max-width: 1240px) {
    width: 18%;
  }

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

/*************** FORM *****************/

export const StyledTxtField = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0;

  div > input {
    box-sizing: border-box;
    height: 54px;
    width: 294px;
    border: 2px solid #979797;
    border-radius: 3px;
    background-color: #ffffff;
    font-size: 1.1em;
    font-weight: 300;
    padding: 10px;
    margin: 5px 0px;

    ::placeholder {    
      opacity: 0.3; 
    }

    ::-ms-input-placeholder {
      opacity: 0.3;
    }

    &.Error {
      border: 2px solid #ca1514;
      padding-right: 40px;
    }
  }
`;

export const StyledInfoMessage = styled.span`
  font-size: 0.8em;
`;

export const StyledError = styled.span`
  font-size: 1em;
  color: #d50000;
  margin-top: 5px;
`;

/*************** TABLE *****************/

export const StyledTable = styled.table`
  border-collapse: collapse;
  color: ${colors.bgSecondary} !important;
  width: 100%;

  tr:nth-child(even) {
    // background: #027b690d;
  }

  th {
    padding: 15px;
    text-align: left;
  }

  td {
    padding: 15px;
    text-align: left;
  }

  thead {
    border: 2px solid
      ${({ theme }: GlobalThemeProps) => theme.backgroundLighter};

    background-color: ${({ theme }: GlobalThemeProps) =>
      theme.backgroundLighter} !important;
    font-weight: bold;

    th{
     background-color: ${({ theme }: GlobalThemeProps) =>
      theme.backgroundLighter} !important;
    }
      
      th.right-align {
          text-align: right;
      }
  }
  

  tbody {
    background-color: ${colors.bgSecondary};
    color: ${colors.txtPrimary};

    tr {
      background-color: ${colors.bgSecondary};
      color: ${colors.txtPrimary};
    }

    td {
      border-top: 1px solid #e7e7e7;
      border-right: 1px solid #e7e7e7;
    }

    td:first-child {
      border-left: 1px solid #e7e7e7;
    }
      
      td.right-align {
          text-align: right;
      }
  }

  tfoot {
    border: 2px solid ${({ theme }: GlobalThemeProps) => theme.backgroundDarker};
       th{
     background-color: ${({ theme }: GlobalThemeProps) =>
      theme.backgroundDarker} !important;
  }

      td{
          background-color: ${({ theme }: GlobalThemeProps) =>
      theme.backgroundDarker};
          padding: 5px;
      }
      
      td.right-align {
          text-align: right;
      }
  }
`;
export const StyledMaterialTableWrapper = styled.div`
  margin: 50px;
  overflow-x: auto;

  @media only screen and (max-width: 700px) {
    margin: 10px;
  }
`;

export const StyledMaterialTable = styled(Table)`
  tr:nth-child(even) {
    // background: #027b690d;
  }

  th {
    color: ${colors.bgSecondary};
  }

  td {
    padding: 15px;
  }

  thead {
    background: ${colors.bgPrimary};
    tr > th {
      color: ${colors.txtPrimary};
      font-weight: bold;
    }
  }

  tbody {
    tr {
      color: ${colors.txtPrimary};

      &.Active {
        background: ${({ theme }: GlobalThemeProps) => theme.backgroundLighter};
      }
    }

    tr > td > button {
      color: white;

      &.NotActive {
        color: ${({ theme }: GlobalThemeProps) => theme.backgroundLighter};
      }
    }

    td:first-child {
    }
  }

  tfoot {
    background: #333333;
    bordertop: 2px solid #333333;

    tr > td {
      color: white;
      font-weight: bold;
    }    
  }

  @media only screen and (max-width: 700px) {
    margin-bottom: 20px;
  }
`;

export const StyledMaterialInnerTable = styled(Table)`
  padding: 0;

  th {
    color: ${colors.bgSecondary};
  }

  td {
    padding: 15px;
  }

  thead {
    tr {
      background: ${({ theme }: GlobalThemeProps) => theme.backgroundLighter};
      border: none;
    }
    tr > th {
      color: ${colors.bgSecondary};
    }
  }

  tbody {
    td {
      border-right: 1px solid ${colors.bgPrimary};
    }

    td:first-child {
    }

    td:last-child {
      border-right: none;    
    }
  }

  tfoot {
    background: ${colors.bgSecondary};
    border: none;

    tr > td {
      color: ${colors.txtPrimary};
      font-weight: bold;
      border: none;
    } 
  }
`;

/*********** ICONS **************** */

export const StyledSyncIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }: GlobalThemeProps) => theme.background};
  margin-left: 10px;
`;

/********** SPINNER ***********/

export const StyledSpinnerWrapper = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 20px;
`;

/*********** FOOTER **************** */

export const StyledFooter = styled.footer`
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: ${({ theme }: GlobalThemeProps) => theme.background};
  color: ${colors.bgSecondary};
  align-items: center;

  p {
    line-height: 20px;
  }
  div {
    padding: 50px;
  }

  @media only screen and (max-width: 700px) {
    flex-direction: column;
    align-items: baseline;
    div {
      padding: 30px;
    }
  }
`;

/********** OTHER STUFF ***********/

export const StyledElement = styled(Element)`
  display: flex;
  justify-content: center;
`;

export const StyledContent = styled.div`
  width: 80%;
  background-color: ${colors.bgSecondary};
  float: right;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 900px) {
    width: 100%;
  }
`;

export const StyledDivPositionFlex = styled.div`
  display: flex;

  @media only screen and (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledWrapper = styled.div`
  width: 100%;
  display: inline-block;
  margin-top: 50px;
  margin-bottom: 100px;
`;

export const AppWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  border-top: 5px solid ${({ theme }: GlobalThemeProps) => theme.background};
`;
